import { useRef } from "react";
import { useTheme } from "@emotion/react";
import { Box, Typography, Paper, Divider, IconButton, Dialog, DialogContent, AppBar, Toolbar } from "@mui/material";
import { CancelOutlined, ArrowBackIos } from "@mui/icons-material";
import Draggable from "react-draggable";
const PaperComponent = ({ canDrag = false, popupStyle, ...props }) => {
  const nodeRef = useRef(null);
  return (
    <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'} disabled={!canDrag}>
      <Paper {...props} ref={nodeRef} sx={{ borderRadius: "10px", ...popupStyle }} />
    </Draggable>
  );
};

const Popup = ({ open = false, onClose, title, children, ...props }) => {
  const isOpen = Boolean(open);
  const theme = useTheme();
  const popupStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: theme.shadows[5],
    minWidth: "900px",
    borderRadius: "10px",
  };
  const expandPopupStyle = {
    position: "fixed",
    maxWidth: "100%",
    minWidth: "100%",
    top: 0,
    left: 0,
    height: "100dvh",
    transform: "none",
    overflow: "auto",
    zIndex: `${theme.zIndex.drawer + 2} !important`,
  };

  return props.noModal ? (
    isOpen && (
      <Box>
        <Draggable disabled={!props.canDrag}>
          <Paper sx={{ ...(props.isExpanded ? expandPopupStyle : popupStyle), ...props.popupStyle }} {...props.paperProps}>
            <Box>
              {!props.isExpanded ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 1,
                    pt: 2,
                    cursor: props.canDrag ? "move" : "default",
                  }}
                >
                  <Box width={"70%"}>
                    <Divider>
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 700,
                          color: "#717273",
                        }}
                      >
                        {title}
                      </Typography>
                    </Divider>
                  </Box>
                  <IconButton sx={{ cursor: "pointer", position: "absolute", right: "12px" }} onClick={onClose}>
                    <CancelOutlined></CancelOutlined>
                  </IconButton>
                </Box>
              ) : (
                <AppBar
                  sx={{
                    zIndex: `${theme.zIndex.drawer + 2} !important`,
                    boxShadow: "none",
                    height: 40,
                    backgroundColor: "white",
                    position: "unset",
                  }}
                >
                  <Toolbar sx={{ color: "black", minHeight: 40, px: 1, zIndex: `${theme.zIndex.drawer + 2} !important` }}>
                    <IconButton color="secondary" onClick={props.onMinimize || onClose}>
                      <ArrowBackIos />
                    </IconButton>
                    {title && (
                      <Box display="flex" justifyContent="center" sx={{ flexGrow: 1 }}>
                        <Box width={200} display="flex">
                          <Box sx={{ flexGrow: 1, borderBottom: `solid 2px ${theme.palette.secondary.main}` }}>
                            <Typography sx={{ fontSize: 16, textAlign: "center" }}>{title}</Typography>
                          </Box>
                          <img src="assets/background/headerbg.png" alt="header" style={{ width: 28, height: 28 }}></img>
                        </Box>
                      </Box>
                    )}
                  </Toolbar>
                </AppBar>
              )}
              {children}
            </Box>
          </Paper>
        </Draggable>
      </Box>
    )
  ) : (
    <Dialog open={isOpen} PaperComponent={PaperComponent} PaperProps={{ ...props.paperProps, sx: props.popupStyle, canDrag: props.canDrag }}>
      {title && (
        <Box
          id="draggable-dialog-title"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 3,
            py: 0.5,
            pr: 3,
            pl: "calc(7% + 24px)",
            color: "#fff",
            cursor: props.canDrag ? "move" : "default",
            background: props.variant ? theme.palette[props.variant].main : theme.palette.secondary.main,
          }}
        >
          <Typography
            variant="h6"
            sx={{ textAlign: "center", width: "100%", maxWidth: "93%", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
          >
            {title}
          </Typography>
          <CancelOutlined sx={{ cursor: "pointer", position: "absolute", right: "8px" }} onClick={onClose}></CancelOutlined>
        </Box>
      )}
      <DialogContent sx={{ p: 0 }}>{children}</DialogContent>
    </Dialog>
  );
};

export default Popup;
